import React, { Component, PropTypes } from 'react';
import ClipboardButton from 'react-clipboard.js'

import './SteamToken.css';

class SteamToken extends Component {
  render() {
    return (
      <ClipboardButton className="SteamToken" data-clipboard-text={this.props.token} onSuccess={this.props.onSuccess}>
        {this.props.token}
      </ClipboardButton>
    );
  }
}

SteamToken.propTypes = {
  onSuccess: PropTypes.func
};

SteamToken.defaultProps = {
  onSuccess: function() {}
};

export default SteamToken;



// WEBPACK FOOTER //
// ./src/components/SteamToken.js